//Reset data
export const RESET = "INBOX_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "INBOX_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INBOX_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INBOX_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INBOX_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "INBOX_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INBOX_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INBOX_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INBOX_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INBOX_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "INBOX_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "INBOX_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INBOX_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INBOX_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INBOX_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "INBOX_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "INBOX_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INBOX_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INBOX_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INBOX_SHOW_SET_MODAL_TYPE"